<template>
  <div class="sales-report__wrapper">

    <div class="css-grid sales-report__header">
      <div class="sales-report__header-name">{{ ucFirst(vendor.vendor) }}</div>
    </div>

    <div class="css-grid sales-vendor-view__container">
      <div class="css-grid sales-vendor-view__row sales-vendor-view__row--header">
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--header">All</div>
        </div>
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--header">Units</div>
        </div>
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--header">Sales</div>
        </div>
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--header">ASP</div>
        </div>
      </div>

      <div class="css-grid sales-vendor-view__row">
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--totals">
            <div class="sales-vendor-view__category-value">Totals</div>
          </div>
        </div>
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--current">
            <div class="sales-vendor-view__category-subtitle">Active</div>
            <div class="sales-vendor-view__category-value">{{ currency(vendor.units) }}</div>
          </div>
          <div class="sales-vendor-view__cell sales-vendor-view__cell--prior">
            <div class="sales-vendor-view__category-subtitle">Runrate</div>
            <div class="sales-vendor-view__category-value">{{ currency(vendor.est_units) }}</div>
          </div>
          <div class="sales-vendor-view__cell sales-vendor-view__cell--change" data-toggle="tooltip" :title="'Runrate vs. Prior '+this.currency(vendor.yoy_units)">
            <div class="sales-vendor-view__category-value" v-bind:class="[ getChangePercent(vendor.est_units, vendor.yoy_units) >= 0 ? 'sales-vendor-view__category-value--positive' : 'sales-vendor-view__category-value--negative']">
              {{ getChangePercent(vendor.est_units, vendor.yoy_units) }}%
            </div>
          </div>
        </div>
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--current">
            <div class="sales-vendor-view__category-subtitle">Active</div>
            <div class="sales-vendor-view__category-value">${{ currency(vendor.sales) }}</div>
          </div>
          <div class="sales-vendor-view__cell sales-vendor-view__cell--prior">
            <div class="sales-vendor-view__category-subtitle">Runrate</div>
            <div class="sales-vendor-view__category-value">${{ currency(vendor.est_sales) }}</div>
          </div>
          <div class="sales-vendor-view__cell sales-vendor-view__cell--change" data-toggle="tooltip" :title="'Runrate vs. Prior $'+this.currency(vendor.yoy_sales)">
            <div class="sales-vendor-view__category-value" v-bind:class="[ getChangePercent(vendor.est_sales, vendor.yoy_sales) >= 0 ? 'sales-vendor-view__category-value--positive' : 'sales-vendor-view__category-value--negative']">
              {{ getChangePercent(vendor.est_sales, vendor.yoy_sales) }}%
            </div>
          </div>
        </div>
        <div class="css-grid sales-vendor-view__category">
          <div class="sales-vendor-view__cell sales-vendor-view__cell--current">
            <div class="sales-vendor-view__category-subtitle">Active</div>
            <div class="sales-vendor-view__category-value">${{ currency(divide(vendor.sales, vendor.units)) }}</div>
          </div>
          <div class="sales-vendor-view__cell sales-vendor-view__cell--prior">
            <div class="sales-vendor-view__category-subtitle">Prior</div>
            <div class="sales-vendor-view__category-value">${{ currency(divide(vendor.yoy_sales, vendor.yoy_units)) }}</div>
          </div>
          <div class="sales-vendor-view__cell sales-vendor-view__cell--change">
            <div class="sales-vendor-view__category-value" v-bind:class="[ getChangePercent(divide(vendor.sales, vendor.units), divide(vendor.yoy_sales, vendor.yoy_units)) >= 0 ? 'sales-vendor-view__category-value--positive' : 'sales-vendor-view__category-value--negative']">
              {{ getChangePercent(divide(vendor.sales, vendor.units), divide(vendor.yoy_sales, vendor.yoy_units)) }}%
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="css-grid sales-report__footer">
      <SalesDetails :months="vendorData" :show="displayDetails" :includeHeader="false"></SalesDetails>
      <div class="sales-report__footer--more" v-on:click="toggleDetails">
        <div class="sales-report__footer-expandable" v-show="showMonths">{{ displayDetails ? '- Show less' : '+ Show details' }}</div>
      </div>
    </div>
  </div>
</template>



<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import SalesDetails from './ReportBoxDetails.vue';
  import DataMethods from '../../utils/DataMethods.js';

  export default {
    name: 'ReportVendor',
    components: {
      SalesDetails,
    },
    mixins: [DataMethods],
    props: ['vendor'],
    data() {
      return {
        displayDetails: false,
        showMonths: false,
        loading: false,
      }
    },
    computed: {
      ...mapGetters('purchaseActivityFlash', [
        'contents',
      ]),
      vendorData() {
        return lodash.filter(this.contents.totalsByVendorByMonth, month => month.vendor == this.vendor.vendor);
      },
    },
    mounted() {
      this.showMonths = (this.filterMonths > 1);
    },
    methods: {
      toggleDetails() {
        this.displayDetails = !this.displayDetails;
        // if (this.filterMonths > 1) {
        //   if (lodash.isEmpty(this.contents.totalsByVendorByMonth)) {
        //     this.$store.dispatch('purchaseActivityFlash/getTotalsByVendorByMonth');
        //   }
        // }
      },
    },
  };
</script>
